import React from "react";
import services from "../../services";
import { withRouter, Route } from "react-router-dom";
import Lang from "../../lang";
import SearchFilter from "../filters/SearchFilter";
import TitleBar from "../common/title_bar";
import $ from "jquery";
import TlkTable from "../tlelrik/table/tlkTable";
import ContaTabsContainer from "../ContaModule/Tabs/TabsContainer";
import queryString from "query-string";
import MovementTabs from "../../components/ContaModule/Tabs/MovementTabs"
import AccountListing from "../../components/ContaModule/AccountListing";
import { Button } from "@progress/kendo-react-buttons";
import moment from "moment";
import RegistoListModalForm from "../../Pages/modules/registo/RegistoListModalForm";
import WizardDetailModalForm from "../common/wizard_detail_popup";


//const dateFormatNoTime = "YYYY-MM-DD";
const dateFormat = "DD-MM-YYYY HH:mm:ss";
const columnKeyMap = {
    numeroRegisto: "Nº de Certificação",
    numeroProcessoLims: "Número de processo LIMS",
    anoProduto: "Ano do produto",
    mencaoComplementar: "Menção complementar",
    mencaoFacultativa: "Menção facultativa",
    mencaoObrigatoria: "Menção qualitativa",
    nivelQualitativo: "Nível qualitativo",
    cor: "Cor",
    grauDocura: "Grau de doçura",
    madeira: "Madeira",
    acidez: "Acidez",
    tav: "TAV (%)",
    validadeRegisto: "Data de Validade",
    dataCriado: "Data criado"
};

const groupfield = [
    //{ field: "Nº Parcela IVDP" },
    //{ field: "Entreposto" },
    // { field: 'Concelho' },
    // { field: 'Freguesia' },
];

const filters = {
    Tabs: {
        Filtros: [
            {
                key: "anoProduto",
                displayKey: "procurar pelo ano do produto",
                inputType: "text",
            }, {
                key: "mencaoObrigatoria",
                displayKey: "procurar pela menção qualitativa",
                inputType: "text",
            }],
        Histórico: [
            {
                key: "numeroRegistoHist",
                displayKey: "procurar por número de certificação",
                inputType: "text",
            }
        ],
    },
    checkbox: [
        {
            key: 'Explorer',
            displayKey: "Exploradora",
            inputType: "radio"
        }

    ],
};

class DashBoardFilter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            entityGrid: "",
            showSearchMsg: false,
            totalcount: 0,
            clickLimparFilter: true,
            entity_list_object: {},
            customfilters: {},
            tlkfilter: {},
            date: new Date(),
            modalToggle: false,
            popUpForm: ''
        };
    }

    componentDidMount() {
        $(window).scrollTop(0);
    }

    componentDidUpdate(proProp) {
        if (proProp.date !== this.props.date) {
            this.setState({
                data: [],
                entityGrid: "",
                showSearchMsg: false,
                totalcount: 0,
                clickLimparFilter: false,
                entity_list_object: {},
                customfilters: {},
                tlkfilter: {},
                date: new Date(),
                modalToggle: false,
                popUpForm: '',
                idRegistoProduto: 0
            });
        }
    }

    getLangFile = () => {
        Lang.getJSON.getJSONFile();
    };

    handleFilter = (data) => {
        console.log("fffffffff", data);
    };

    createTable = async () => {
        // const columnList = Object.keys(columnKeyMap).map((key) => ({
        //     field: columnKeyMap[key],
        //     columnMenuType: "checkbox",
        // }));

        var columnList = [];

        Object.keys(columnKeyMap).forEach(e => {
            if (e == "numeroRegisto" || e == "numeroProcessoLims" || e == "anoProduto") {
                columnList.push({ field: columnKeyMap[e], columnMenuType: "number" });
            }
            else {
                columnList.push({ field: columnKeyMap[e], columnMenuType: "checkbox" });
            }
        });

        console.log("COLUNAS REGISTO");
        console.log(columnList);
        const actionbuttons = {
            CommonRedirection: "Detalhes do registo",
        };
        const entityGrid = (
            <TlkTable
                date={new Date()}
                // sendDatatoTlkTable={(filter) => this.sendDataToGrid(filter)}
                list={this.state.data}
                modulename={"Registo"}
                notAction={false}
                actionbuttons={actionbuttons}
                // notGroup={true}
                columnlist={columnList}
                groupfield={groupfield}
                ActionPerform={(action, id) =>
                    this.ActionPerform(action, id)}
            // selection={ true }
            // selectionChange={ (e) => this.selectionChange(e) }
            />
        );
        await this.setState({ entityGrid });
    };

    getFilters(filters) {
        if (!this.props.match.isExact) {
            this.props.history.push("/registo");
        }
        this.setState(
            {
                customfilters: filters,
                totalcount: 0,
                clickLimparFilter: false,
                showSearchMsg: false,
                entityGrid: null,
            },
            () => {
                if (
                    filters &&
                    (Object.keys(filters.filters).length > 0 ||
                        Object.keys(filters.filterCheckbox).length > 0)
                ) {
                    this.sendDataToGrid();
                }
            }
        );
    }

    makeAllFilters = () => {
        const customFilters = { ...this.state.customfilters };
        return {
            Filters: {
                numeroRegisto: +customFilters.filters.numeroRegisto
                    ? +customFilters.filters.numeroRegisto
                    : null,
                numeroRegistoHist: +customFilters.filters.numeroRegistoHist
                    ? +customFilters.filters.numeroRegistoHist
                    : null,
                anoProduto: +customFilters.filters.anoProduto
                    ? +customFilters.filters.anoProduto
                    : null,
                mencaoObrigatoria: customFilters.filters.mencaoObrigatoria
                    ? customFilters.filters.mencaoObrigatoria
                    : null
            },
            FiltersIn: null,
            FiltersLike: null,
            SortBy: "NumeroRegisto",
            IsSortTypeDESC: true,
            IsPagination: false,
            Page: 2,
            PageSize: 2,
        };
    };
    closePopup = () => {
        this.setState({
            modalToggle: false
        });
        $(".left-popup").trigger("click");
        this.updatesel_nev(this.state.sel_nev);
    };

    updatesel_nev = (sel_nev) => {
        this.setState({
            sel_nev,
        });
        if ($("#" + sel_nev).length) {
            $("html, body").animate(
                {
                    scrollTop: $("#" + sel_nev).offset().top - 95, //#DIV_ID is an example. Use the id of your destination on the page
                },
                "slow"
            );
        }
    }

    insertClickPopUp = (data) => {
        this.setState({
            modalToggle: true,
            popUpForm: ""
        })

        let popUpForm = (
            <RegistoListModalForm
                date={new Date()}
                data = {data}
                toggle={this.state.modalToggle}
                closePopup={() => this.closePopup()}
            />
        )
        this.setState({
            popUpForm
        })
    }

    sendDataToGrid = async () => {
        let { customfilters } = this.state;
        if (
            customfilters &&
            Object.keys(customfilters.filters).length == 0 &&
            Object.keys(customfilters.filterCheckbox).length == 0
        ) {
            return;
        }
        const filters = this.makeAllFilters();

        var apiUrl = customfilters.filters.numeroRegistoHist ? "Registo/GetAllHist" : "Registo/GetAll";

        const response = await services.apiCall.requestApi(
            apiUrl,
            filters,
            "post"
        );

        if (response && response.length > 0) {
            const data = response.map((entity, index) => ({
                ...entity,
                ...Object.keys(columnKeyMap).map((key) => {
                    if (key === "dataCriado") {
                        entity[columnKeyMap[key]] = moment(
                            entity.dataCriado
                        ).format(dateFormat)
                    } else if (key === "anoProduto") {
                        let anoProduto = entity["anoProduto"] === 0 ? "nd" : entity["anoProduto"];
                        entity[columnKeyMap[key]] = anoProduto;
                    }
                    else {
                        entity[columnKeyMap[key]] = entity[key];
                    }
                }),
                selected: false,
            }));
            this.setState(
                {
                    data,
                    showSearchMsg: false,
                    totalcount: window.localStorage.getItem("table_total"),
                },
                () => {
                    console.log("887788 data", this.state.data);
                    this.createTable();
                }
            );
        } else {
            this.setState({ showSearchMsg: true });
        }
    };

    /*  Para realizar a ação com base na seleção da tabela  */
    ActionPerform = async (action, row) => {
        // TODO: Rohit — Export data from grid
        if (action === "Detalhes do registo") {
           
            let data = await this.getDetails(row.idRegistoProduto, row.numeroRegisto)
            this.insertClickPopUp(data);
           
        }
    };

    getDetails = async (idRegistoProduto, numeroRegisto) => {

        let link = "Registo/GetDetailFromRegisto";
        let request = {IDRegistoProduto : idRegistoProduto};
        let method = "post";
        let res = await services.apiCall.requestApi(link, request, method);
        if (res) {
            return {
                res: res,
                numeroRegisto: numeroRegisto                
            };
        } else {
            return {
                res: [],
                numeroRegisto: ""
            };
        }
    };
    backToSearch = () => {
        this.props.history.push("/registo");
    };

    refreshComponent = () => {
        this.setState({ clickLimparFilter: true });
    };

    /*  Para renderizar o conteúdo html da página   */
    render() {
        return (
            <div className="inner-container">
                <div className="outer-space">
                    <TitleBar
                        title="Certificação"
                        refreshComponent={() => this.refreshComponent()}
                        onlyInicioLink={"/registo"}
                        logo="registo"
                    />
                </div>
                <div className="container-fluid">

                    <SearchFilter
                        optionText="Pesquisa por Número de Certificação"
                        registoProdComponent={true}
                        date={this.state.date}
                        filters={filters}
                        moduleType="Registo"
                        clickLimparFilter={this.state.clickLimparFilter}
                        data={this.state.data}
                        handleFilter={(data) => this.handleFilter(data)}
                        getFilter={(data) => this.getFilters(data)}

                    />

                    <div className="table-section custom-k-grid pt-3">
                        {this.props.match.isExact && (
                            <>
                                {
                                    <div
                                        className={
                                            this.state.data &&
                                                this.state.data.length
                                                ? ""
                                                : "tlkwodata"
                                        }
                                    >
                                        {this.state.totalcount > 0 && (
                                            <h3>
                                                {" "}
                                                A pesquisa retornou{" "}
                                                {this.state.totalcount}{" "}
                                                {this.state.totalcount > 1 ? "produtos" : "produto"}
                                            </h3>
                                        )}
                                        <div className="table-responsive">
                                            {this.state.entityGrid}
                                        </div>
                                    </div>
                                }
                                {this.state.totalcount == 0 && (
                                    <div className="searct-found">
                                        <img
                                            className="img-fluid"
                                            src="imgs/data-certificadolab2.png"
                                            alt="Pesquisa por Número de registo"
                                        />
                                        {this.state.showSearchMsg ? (
                                            <p className="font-14">
                                                Sem resultados
                                            </p>
                                        ) : (
                                            <h3>
                                                Pesquise pelo número de certificação do produto para apresentação de mais informações
                                            </h3>
                                        )}
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                    <div className="modal left-popup" id="registo-left-popup">
                        <div className="modal-dialog modal-sm">
                            {
                                this.state.popUpForm
                            }
                        </div>
                    </div>                
                </div>
            </div>

        );
    }
}

export default withRouter(DashBoardFilter);
